import React from 'react';
import { Row, Col, Card, CardBody, CardHeader, Table, Badge } from 'reactstrap';

import { formatDateTimeWib } from '../../formatters';

// Kartu bersama tab-tab Tender Opening (desain acuan): "Informasi Header
// Tender" dan "Cargo Requirement (Read-Only)" tampil identik di tab Sending
// Request HPS dan Sending Invitation to DMUT, jadi diekstrak ke satu file.

// Nilai UTC -> tanggal ISO wall-clock Jakarta ("2026-09-01") untuk kolom DDR
// (desain acuan menampilkan format ISO, bukan "01 Sep 2026").
export const isoDateJakarta = value => {
  if (!value) return '-';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleDateString('en-CA', { timeZone: 'Asia/Jakarta' });
};

export const HeaderTenderCard = ({ record, detail }) => {
  const validity = detail?.requirement?.validity || {};
  return (
    <Card className='border shadow-none mb-3'>
      <CardHeader className='bg-light d-flex align-items-center'>
        <span className='fw-semibold flex-grow-1'>
          <i className='ri-information-line align-middle me-2'></i>
          Informasi Header Tender
        </span>
        <Badge color='light' className='text-body border font-monospace'>
          {record?.procId}
        </Badge>
      </CardHeader>
      <CardBody>
        <Row className='g-3'>
          <Col lg={6}>
            <div className='border rounded p-2 h-100'>
              <small className='text-muted d-block'>Title</small>
              <span className='fw-semibold'>{record?.title || '-'}</span>
            </div>
          </Col>
          <Col lg={3} sm={6}>
            <div className='border rounded p-2 h-100'>
              <small className='text-muted d-block'>Mekanisme Pengadaan</small>
              <span className='fw-semibold'>
                {record?.procurementMethod || '-'}
              </span>
            </div>
          </Col>
          <Col lg={3} sm={6}>
            <div className='border rounded p-2 h-100'>
              <small className='text-muted d-block'>Periode Kebutuhan</small>
              <span className='fw-semibold'>
                {detail?.requirement?.contractType || '-'}
              </span>
            </div>
          </Col>
        </Row>

        <p className='form-label mt-3 mb-2 fs-13 fw-semibold'>
          <i className='ri-calendar-check-line align-middle me-2'></i>
          Validity Pengajuan Penawaran
        </p>
        <Row className='g-2'>
          <Col lg={6}>
            <div className='d-flex justify-content-between border rounded px-3 py-2'>
              <span className='text-muted fs-13'>
                Submission Document (Jakarta Local Time)
              </span>
              <span className='fw-semibold font-monospace fs-13'>
                {formatDateTimeWib(validity.submissionDeadline)}
              </span>
            </div>
          </Col>
          <Col lg={6}>
            <div className='d-flex justify-content-between border rounded px-3 py-2'>
              <span className='text-muted fs-13'>
                Due Date Expired Quotation (Jakarta Local Time)
              </span>
              <span className='fw-semibold font-monospace fs-13'>
                {formatDateTimeWib(validity.validityPeriod)}
              </span>
            </div>
          </Col>
        </Row>

        <div className='border rounded px-3 py-2 mt-2 bg-light'>
          <span className='text-muted fs-13 me-2'>Remarks / Catatan:</span>
          <span className='fs-13'>{record?.description || '-'}</span>
        </div>
      </CardBody>
    </Card>
  );
};

export const CargoRequirementCard = ({ cargos = [] }) => (
  <Card className='border shadow-none mb-3'>
    <CardHeader className='bg-light d-flex align-items-center'>
      <span className='fw-semibold flex-grow-1'>
        <i className='ri-ship-line align-middle me-2'></i>
        Cargo Requirement
      </span>
      <span className='badge bg-secondary-subtle text-secondary border'>
        <i className='ri-lock-line me-2'></i>
        Submitted Planning Data (Read-Only)
      </span>
    </CardHeader>
    <CardBody className='p-0'>
      <div className='table-responsive'>
        <Table className='table-sm align-middle table-nowrap mb-0'>
          <thead className='table-light'>
            <tr className='text-uppercase fs-12 text-muted'>
              <th>Cargo Type</th>
              <th>Parcel Size</th>
              <th>OT (%)</th>
              <th>Incoterms</th>
              <th>Incoterms Notes</th>
              <th>Delivery</th>
              <th>Delivery Date Range (DDR)</th>
              <th>DDR Notes</th>
              <th className='text-center'>Action</th>
            </tr>
          </thead>
          <tbody>
            {cargos.length === 0 ? (
              <tr>
                <td colSpan={9} className='text-center text-muted py-3'>
                  No cargo data
                </td>
              </tr>
            ) : (
              cargos.map(c => (
                <React.Fragment key={c.id}>
                  <tr>
                    <td className='fw-semibold'>{c.cargoType}</td>
                    <td className='fw-semibold'>
                      {c.volume != null && c.volume !== ''
                        ? `${c.volume} Kbbl`
                        : '-'}
                    </td>
                    <td>
                      {c.ot != null ? `(±) ${c.ot}%` : '-'}
                      {c.otOption ? ` ${c.otOption}` : ''}
                    </td>
                    <td className='text-primary fw-semibold'>
                      {(c.incoterms || []).join('/') || '-'}
                    </td>
                    <td>{c.incotermsNotes || '-'}</td>
                    <td>
                      {c.plant} {c.unit}
                    </td>
                    <td className='font-monospace fs-12'>
                      {isoDateJakarta(c.ddrFrom)} s/d {isoDateJakarta(c.ddrTo)}
                    </td>
                    <td>{c.ddrNotes || '-'}</td>
                    <td className='text-center'>
                      <span className='badge bg-light text-muted border'>
                        Read-Only
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={9} className='p-3 bg-light-subtle'>
                      <p className='fw-semibold fs-13 text-primary mb-2'>
                        <i className='ri-drop-line align-middle me-2'></i>
                        Crude / Condensate Selected ({
                          (c.crudes || []).length
                        }{' '}
                        items)
                      </p>
                      <div className='table-responsive bg-white border rounded'>
                        <Table className='table-sm align-middle mb-0'>
                          <thead className='table-light'>
                            <tr className='text-uppercase fs-12 text-muted'>
                              <th>Crude Oil</th>
                              <th>Max Capacity</th>
                              <th>Remark Max Capacity</th>
                              <th className='text-center'>Is Via CIB Only?</th>
                              <th>% Blending Crude 1</th>
                              <th>% Blending Crude 2</th>
                              <th className='text-center'>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {(c.crudes || []).length === 0 ? (
                              <tr>
                                <td
                                  colSpan={7}
                                  className='text-center text-muted py-2'
                                >
                                  No crude / condensate data
                                </td>
                              </tr>
                            ) : (
                              c.crudes.map(cr => (
                                <tr key={cr.id}>
                                  <td className='fw-semibold'>
                                    {cr.crudeName}
                                  </td>
                                  <td>{cr.maxCapacity ?? '-'}</td>
                                  <td>{cr.remarkMaxCapacity || '-'}</td>
                                  <td className='text-center'>
                                    {cr.isViaCibOnly ? 'Yes' : 'No'}
                                  </td>
                                  <td>
                                    {cr.bleeding1 != null
                                      ? `${cr.bleeding1}%`
                                      : '-'}
                                  </td>
                                  <td>
                                    {cr.bleeding2 != null
                                      ? `${cr.bleeding2}%`
                                      : '-'}
                                  </td>
                                  <td className='text-center'>
                                    <span className='badge bg-light text-muted border'>
                                      <i className='ri-lock-line me-2'></i>
                                      Locked
                                    </span>
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </Table>
                      </div>
                    </td>
                  </tr>
                </React.Fragment>
              ))
            )}
          </tbody>
        </Table>
      </div>
    </CardBody>
  </Card>
);
